/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Recap_Voice_VInputs */

const en_funnel_ob_recap_voice_v = /** @type {(inputs: Funnel_Ob_Recap_Voice_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarlett · natural`)
};

const es_funnel_ob_recap_voice_v = /** @type {(inputs: Funnel_Ob_Recap_Voice_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarlett · natural`)
};

/**
* | output |
* | --- |
* | "Scarlett · natural" |
*
* @param {Funnel_Ob_Recap_Voice_VInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_recap_voice_v = /** @type {((inputs?: Funnel_Ob_Recap_Voice_VInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Recap_Voice_VInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_recap_voice_v(inputs)
	return en_funnel_ob_recap_voice_v(inputs)
});